import React from "react"
import { AppBulkEditAction } from "@components"
import {useUserSettingsTier, useUserSettingsTierValidator} from "../../@hooks"


export default function UserSettingTierDrawerSubmit() {
	const {isLoading, handleSubmitTierFormData} = useUserSettingsTier()
	const {isValid} = useUserSettingsTierValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitTierFormData}
	>
		Save
	</AppBulkEditAction>
}